import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createLanding } from "../../../api/landing.api";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import LandingPageEditor from "../../../components/landing/page/Editor";

const LandingCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/landing/page');
    }
  }, [res, isLoading]);
  const submit = (data: FormData) => {
    execute(createLanding(data));
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('homepage.landing.title1')}
        currentMenu={t('homepage.landing.title2')}
      />
      <LandingPageEditor
        submit={submit}
        mode="create"
      />
    </div>
  );
}

export default LandingCreate;
